import C from '../../assets/images/skills/C.png';
import Cpp from '../../assets/images/skills/C++.png';
import Java from '../../assets/images/skills/java.png';
import Python from '../../assets/images/skills/python.png';
import HTML from '../../assets/images/skills/HTML.png';
import CSS from '../../assets/images/skills/CSS.png';
import Bootstrap from '../../assets/images/skills/bootstrap.png';
import JavaScript from '../../assets/images/skills/javascript.png';
import JQuery from '../../assets/images/skills/jquery.png';
import React from '../../assets/images/skills/react.png';
import NodeJS from '../../assets/images/skills/node-js.png';
import API from '../../assets/images/skills/API.png';
import SQL from '../../assets/images/skills/sql.png';
import MongoDB from '../../assets/images/skills/mongodb.png';
import AI from '../../assets/images/skills/AI.png';
import DSA from '../../assets/images/skills/DSA.png';
import Blockchain from '../../assets/images/skills/blockchain.png';
import GitHub from '../../assets/images/skills/github.png';
import Typing from '../../assets/images/skills/typing.png';
import Piano from '../../assets/images/skills/piano.png';

const MySkills = [
    {
        id: 1,
        image: C,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 2,
        image: Cpp,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 3,
        image: Java,
        rating: "⭐⭐⭐"
    },
    {
        id: 4,
        image: Python,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 5,
        image: HTML,
        rating: "⭐⭐⭐⭐⭐"
    },
    {
        id: 6,
        image: CSS,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 7,
        image: Bootstrap,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 8,
        image: JavaScript,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 9,
        image: JQuery,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 10,
        image: React,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 11,
        image: NodeJS,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 12,
        image: API,
        rating: "⭐⭐⭐⭐⭐"
    },
    {
        id: 13,
        image: SQL,
        rating: "⭐⭐⭐⭐"
    },
    {
        id: 14,
        image: MongoDB,
        rating: "⭐⭐⭐"
    },
    {
        id: 15,
        image: AI,
        rating: "⭐⭐"
    },
    {
        id: 16,
        image: DSA,
        rating: "⭐⭐⭐"
    },
    {
        id: 17,
        image: Blockchain,
        rating: "⭐⭐⭐"
    },
    {
        id: 18,
        image: GitHub,
        rating: "⭐⭐⭐"
    },
    {
        id: 19,
        image: Typing,
        rating: "⭐⭐⭐"
    },
    {
        id: 20,
        image: Piano,
        rating: "⭐⭐⭐"
    }
];

export default MySkills;
